module.exports = __webpack_public_path__ + "static/media/7news-reversed.d5f52046.png";